import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import service from 'util/apiService';
import { UPDATE_DRAFT_ALERT } from '../../../modules/cbre-flow-Common/constants/ActionTypes';
import { getUserAccess } from 'modules/cbre-flow-api-ducks/selectors';

const DraftCountProvider = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const { site, client } = useSelector(getUserAccess);
  const saveDraftUrl = useSelector(
    (state: any) =>
      state.config?.client?.flowApiUrl + `api/work-request/draft/counts?clientCode=${client?.clientCode}`, // Fix endpoint URL
  );

  useEffect(() => {
    const fetchDraftCounts = async () => {
      try {
        console.log('Fetching draft counts from:', saveDraftUrl);
        const response = await service.get(saveDraftUrl);

        if (response && response.data) {
          dispatch({
            type: UPDATE_DRAFT_ALERT,
            payload: response.data.draftInstrumentCount,
          });
        }
      } catch (error) {
        console.error('Error fetching draft counts:', error);
      }
    };

    // Only fetch if URL is available
    if (saveDraftUrl) {
      fetchDraftCounts();

      const intervalId = setInterval(fetchDraftCounts, 5 * 60 * 1000); // every 5 minutes

      return () => clearInterval(intervalId);
    }
  }, [dispatch, saveDraftUrl]); // Add saveDraftUrl as dependency

  return <>{children}</>;
};

export default DraftCountProvider;
